export default __webpack_public_path__ + "static/how-it-works-3-a3b5ba36a4b18939b8046626909ce07e.png";